import { Auth0Context } from '@auth0/auth0-react';
import { MoonIcon, SunIcon } from '@radix-ui/react-icons';
import { Button, Flex, IconButton } from '@radix-ui/themes';
import { ErrorBoundary } from 'components/common/error-boundary';
import { LoginFormAuth0 } from 'components/main/landing/forms/auth0';
import { LoginFormLegacy } from 'components/main/landing/forms/legacy';
import { ResetPasswordForm } from 'components/main/landing/forms/reset-password';
import env from 'config';
import useLogout from 'hooks/useLogout';
import { t } from 'i18next';
import { LoginMethod } from 'lib_ts/enums/auth.enums';
import { RADIX, RadixAppearance } from 'lib_ts/enums/radix-ui';
import { useContext, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { paths } from 'routes/paths';
import useMiscStore from 'stores/use-misc-store';

export const Login = () => {
  const auth0Cx = useContext(Auth0Context);
  const [method, setMethod] = useState<LoginMethod>(env.login_methods[0]);

  const isDarkMode = useMiscStore((s) => s.isDarkMode);

  const { logout } = useLogout();

  return (
    <ErrorBoundary identifier="Login" hideIntercom>
      <Routes>
        {env.login_methods.includes(LoginMethod.Auth0) && (
          <Route path={paths.login.auth0} element={<LoginFormAuth0 />} />
        )}

        {env.login_methods.includes(LoginMethod.Legacy) && (
          <Route path={paths.login.legacy} element={<LoginFormLegacy />} />
        )}

        {env.login_methods.includes(LoginMethod.Legacy) && (
          <Route path="/reset-password" element={<ResetPasswordForm />} />
        )}

        <Route
          path="*"
          element={
            <>
              {method === LoginMethod.Auth0 && <LoginFormAuth0 />}

              {method === LoginMethod.Legacy && <LoginFormLegacy />}

              <Flex
                gap={RADIX.FLEX.GAP.LG}
                justify="between"
                style={{
                  position: 'fixed',
                  bottom: 0,
                  left: 0,
                  right: 0,
                }}
                pt="2"
                pb="2"
                pl="4"
                pr="4"
              >
                <Flex gap={RADIX.FLEX.GAP.SM}>
                  {env.login_methods.map((m, i) => (
                    <Button
                      key={`login-method-${i}`}
                      className="btn-floating"
                      variant="soft"
                      color={RADIX.COLOR.NEUTRAL}
                      onClick={() => setMethod(m)}
                    >
                      {m}
                    </Button>
                  ))}
                  {auth0Cx.isAuthenticated && (
                    <Button
                      color={RADIX.COLOR.NEUTRAL}
                      className="btn-floating"
                      variant="soft"
                      onClick={() => logout()}
                    >
                      {t('main.logout')}
                    </Button>
                  )}
                </Flex>

                <IconButton
                  className="btn-floating"
                  color={RADIX.COLOR.NEUTRAL}
                  variant="soft"
                  onClick={() => {
                    useMiscStore
                      .getState()
                      .setAppearance(
                        isDarkMode
                          ? RadixAppearance.Light
                          : RadixAppearance.Dark
                      );
                  }}
                >
                  {isDarkMode ? <SunIcon /> : <MoonIcon />}
                </IconButton>
              </Flex>
            </>
          }
        />
      </Routes>
    </ErrorBoundary>
  );
};

export default Login;
